import { Zombie } from "./zombie";
import { Waves } from "./waves";
import { Player } from "./player";
import * as zombieData from "./zombieData.json";
import * as waveData from "./waveData.json";
import { Maps } from "./maps"; // typescript was being dumb and wouldnt recognize "Maps" without the direct reference
import { Scene } from "phaser";
export class Zombies {
	// zombieNum = 0;
	zombiePathTime = 0;
	self: Phaser.Physics.Arcade.Group;
	// zombieSpawnDelay = 1500;
	lastZombieSpawnTime = 0;
	wave: WaveJSON;
	zombieIndex: number; // keep track of where we are in spawning zombies
	zombieWave: string[]; // list of zombies to be spawned this wave
	activeZombies: number; // active zombies. Check for new wave at 0, if zombieIndex is maxed
	allowZombieCollide = false;

	// SOUNDS!
	hurt: Phaser.Sound.BaseSound[];

	death: Phaser.Sound.BaseSound[];

	constructor() // world: Phaser.Physics.Arcade.World,
	// scene: Phaser.Scene
	{
		// super(world, scene, {
		// 	classType: Zombie,
		// 	runChildUpdate: true,
		// });
	}
	// This is where the sprite sheets are loaded. with the frame sizes determined by measuring the sprite sheets in paint.
	preload(scene: Phaser.Scene): void {
		// scene.load.spritesheet("blueZombie", "assets/DinoSprites - doux_extruded.png", {
		// 	frameWidth: 24,
		// 	frameHeight: 24,
		// 	margin:1,
		// 	spacing:2
		// });
		// scene.load.spritesheet("redZombie", "assets/DinoSprites - mort_extruded.png", {
		// 	frameWidth: 24,
		// 	frameHeight: 24,
		// 	margin:1,
		// 	spacing:2

		// });
		// scene.load.spritesheet("yellowZombie", "assets/DinoSprites - tard_extruded.png", {
		// 	frameWidth: 24,
		// 	frameHeight: 24,
		// 	margin:1,
		// 	spacing:2
		// });
		// scene.load.spritesheet("greenZombie", "assets/DinoSprites - vita_extruded.png", {
		// 	frameWidth: 24,
		// 	frameHeight: 24,
		// 	margin:1,
		// 	spacing:2
		// });

		// SOUND!
		scene.load.audio("hurt4", ["release_assets/sound/hurt4.wav"]);
		scene.load.audio("hurt5", ["release_assets/sound/hurt5.wav"]);
		scene.load.audio("hurt6", ["release_assets/sound/hurt6.wav"]);
		scene.load.audio("death1", ["release_assets/sound/death1.wav"]);
		scene.load.audio("death2", ["release_assets/sound/death2.wav"]);
		scene.load.audio("death3", ["release_assets/sound/death3.wav"]);
	}
	// This is run to initialize the everything.
	create(scene: Phaser.Scene, map: Maps, waves: Waves): void {
		this.wave = waves.getCurrentWave();
		this.zombieWave = waves.getZombiesForWave();
		this.zombieIndex = 0;
		this.activeZombies = 0;
		this.lastZombieSpawnTime = 0;
		this.self = scene.physics.add.group({
			classType: Zombie,
			runChildUpdate: true
		});

		const config: Phaser.Types.Sound.SoundConfig = {
			volume: 0.1
		};

		this.hurt = [
			scene.sound.add("hurt4", config),
			scene.sound.add("hurt5", config),
			scene.sound.add("hurt6", config)
		];
		this.death = [
			scene.sound.add("death1", config),
			scene.sound.add("death2", config),
			scene.sound.add("death3", config)
		];

		// This initializes the zombies collision detection with itself. "When Zombie collides with Zombie, run zombiecollide"
		scene.physics.add.collider(this.self, this.self, this.zombieCollide);
		// Collide zombies with the map as well
		// scene.physics.add.collider(this.self, map.collision);
		const zombieIds: { [index: string]: string } = {
			yellow: "tard",
			red: "mort",
			green: "vita",
			blue: "doux"
		};
		for (const zombieColor of ["red", "blue", "green", "yellow"]) {
			const runFrameNames = scene.anims.generateFrameNames("sprites", {
				start: 17,
				end: 23,
				zeroPad: 1,
				prefix: `split/DinoSprites - ${zombieIds[zombieColor]}-`,
				suffix: ".png"
			});
			scene.anims.create({
				// Give it a name
				key: `zombie${zombieColor}run`,
				// Choose which portions of the sprite sheet to scroll through
				frames: runFrameNames,
				// Determine the base speed that we scroll through this bad boy
				frameRate: 10,
				// Set it to repeat forever
				repeat: -1
			});
			// scene.anims.create({
			// 	// Give it a name
			// 	key: `zombie${zombieColor}run`,
			// 	// Choose which portions of the sprite sheet to scroll through
			// 	frames: scene.anims.generateFrameNumbers(`${zombieColor}Zombie`, {
			// 		start: 17,
			// 		end: 23
			// 	}),
			// 	// Determine the base speed that we scroll through this bad boy
			// 	frameRate: 10,
			// 	// Set it to repeat forever
			// 	repeat: -1
			// });
			const walkFrameNames = scene.anims.generateFrameNames("sprites", {
				start: 4,
				end: 9,
				zeroPad: 1,
				prefix: `split/DinoSprites - ${zombieIds[zombieColor]}-`,
				suffix: ".png"
			});
			scene.anims.create({
				// Give it a name
				key: `zombie${zombieColor}walk`,
				// Choose which portions of the sprite sheet to scroll through
				frames: walkFrameNames,
				// Determine the base speed that we scroll through this bad boy
				frameRate: 10,
				// Set it to repeat forever
				repeat: -1
			});
			// scene.anims.create({
			// 	key: `zombie${zombieColor}walk`,
			// 	frames: scene.anims.generateFrameNumbers(`${zombieColor}Zombie`, {
			// 		start: 4,
			// 		end: 9
			// 	}),
			// 	frameRate: 10,
			// 	repeat: -1
			// });
			// These only have 1 frame of animation, as they are not moving.
			const idleFrameNames = scene.anims.generateFrameNames("sprites", {
				start: 0,
				end: 0,
				zeroPad: 1,
				prefix: `split/DinoSprites - ${zombieIds[zombieColor]}-`,
				suffix: ".png"
			});
			scene.anims.create({
				// Give it a name
				key: `zombie${zombieColor}idle`,
				// Choose which portions of the sprite sheet to scroll through
				frames: idleFrameNames,
				// Determine the base speed that we scroll through this bad boy
				frameRate: 20
			});
			// scene.anims.create({
			// 	key: `zombie${zombieColor}idle`,
			// 	frames: [
			// 		{
			// 			key: `${zombieColor}Zombie`,
			// 			frame: 0
			// 		}
			// 	],
			// 	frameRate: 20
			// });
			// And now, pain animations!
			const hurtFrameNames = scene.anims.generateFrameNames("sprites", {
				start: 14,
				end: 16,
				zeroPad: 1,
				prefix: `split/DinoSprites - ${zombieIds[zombieColor]}-`,
				suffix: ".png"
			});
			scene.anims.create({
				// Give it a name
				key: `zombie${zombieColor}hurt`,
				// Choose which portions of the sprite sheet to scroll through
				frames: hurtFrameNames,
				// Determine the base speed that we scroll through this bad boy
				frameRate: 12,
				repeat: 0
			});
			// scene.anims.create({
			// 	key: `zombie${zombieColor}hurt`,
			// 	frames: scene.anims.generateFrameNumbers(`${zombieColor}Zombie`, {
			// 		start: 14,
			// 		end: 16
			// 	}),
			// 	frameRate: 12,
			// 	repeat: 0
			// });
			// And now, dying animations!
			const dyingFrameNames = scene.anims.generateFrameNames("sprites", {
				start: 14,
				end: 16,
				zeroPad: 1,
				prefix: `split/DinoSprites - ${zombieIds[zombieColor]}-`,
				suffix: ".png"
			});
			scene.anims.create({
				// Give it a name
				key: `zombie${zombieColor}dying`,
				// Choose which portions of the sprite sheet to scroll through
				frames: dyingFrameNames,
				// Determine the base speed that we scroll through this bad boy
				frameRate: 12,
				repeat: 0
			});
			// scene.anims.create({
			// 	key: `zombie${zombieColor}dying`,
			// 	frames: scene.anims.generateFrameNumbers(`${zombieColor}Zombie`, {
			// 		start: 16,
			// 		end: 16
			// 	}),
			// 	frameRate: 12,
			// 	repeat: 0
			// });
		}
	}

	// This is run with the scene update funcitons, so when the frame updates, so will this, the zombie manager.
	update(
		time: number,
		delta: number,
		scene: Phaser.Scene,
		player: Player,
		map: Maps,
		waves: Waves
	): void {
		const zombieChildren: Phaser.GameObjects.GameObject[] = this.self.getChildren();
		const zombieJSON: { [index: string]: ZombieJSON } = zombieData;
		const waveJSON: { [index: string]: WaveJSON } = waveData;
		// if no active zombies, and we've finished this wave
		if (this.activeZombies === 0 && this.zombieIndex === this.zombieWave.length) {
			if (waves.advanceWave(time)) {
				this.wave = waves.getCurrentWave();
				this.zombieWave = waves.getZombiesForWave();
				this.zombieIndex = 0;
			} else if (this.wave.repeatable === false) {
				// You won! TODO
			} else {
				// redo this wave if we arent waiting
				if (waves.isInWaveDelay() === false) {
					this.zombieWave = waves.getZombiesForWave();
					this.zombieIndex = 0;
				}
			}
		}
		// if we have more zombies to spawn this wave
		if (this.zombieIndex < this.zombieWave.length) {
			// if we've waited long enought to spawn a zombie
			if (this.lastZombieSpawnTime + this.wave.delayBetweenSpawns < time) {
				// increment our counters
				this.lastZombieSpawnTime = time;
				this.activeZombies = this.activeZombies + 1;
				// get a new zombie
				const zambie: Zombie = this.self.get() as Zombie;
				// find a valid spawn point for this zombie based on the wave
				const spawnPoints: TiledObject[] = map.self.filterObjects(
					"Events",
					(obj: Phaser.GameObjects.GameObject): boolean => {
						return this.wave.spawns.indexOf(obj.name) > -1;
					}
				);
				const spawnPoint: TiledObject = Phaser.Utils.Array.GetRandom(
					spawnPoints
				) as TiledObject;
				const waveNum: number = waves.getCurrentWaveNumber();
				// spawn the zombie and pathfind it towards the player
				zambie.newSpawn(scene, this.zombieWave[this.zombieIndex], waveNum, spawnPoint);
				this.zombieIndex = this.zombieIndex + 1;
				const path: Phaser.Geom.Point[] = map.navMesh.findPath(
					{ x: zambie.x, y: zambie.y },
					{ x: player.self.x, y: player.self.y }
				);
				zambie.newTarget(path);
				zambie.setActive(true).setVisible(true);
			}
		}
		// map.navMesh.debugDrawClear(); // Clears the overlay
		for (const child of zombieChildren as Zombie[]) {
			// check each zombie(singular) every update and see if they are active, but have no health.
			if (child.active === true && child.isDead === true) {
				// if they are active and have no health, remove them from the play field.
				child.x = -100;
				child.y = -100;
				child.setActive(false).setVisible(false);
				child.setVelocity(0, 0);
				this.activeZombies = this.activeZombies - 1;
				if (child.health <= 0) {
					player.points = player.points + child.score;
				}
			}
			// If they have just entered hitstun, play a hurt noise...
			if (child.hitstunFlag === true && child.active === true) {
				// Unless it died, in which case play the death noise instead...
				if (child.health <= 0) {
					const whichSound: Phaser.Sound.BaseSound = Phaser.Utils.Array.GetRandom(
						this.death
					);

					if (!whichSound.isPlaying) {
						whichSound.play();
					}
				} else {
					const whichSound: Phaser.Sound.BaseSound = Phaser.Utils.Array.GetRandom(
						this.hurt
					);

					if (!whichSound.isPlaying) {
						whichSound.play();
					}
				}
			}
			// if they arent dead, and want a new path
			if (child.active === true && child.isDead === false && child.requestNewPath === true) {
				child.requestNewPath = false;
				const path: Phaser.Geom.Point[] = map.navMesh.findPath(
					{ x: child.x, y: child.y },
					{ x: player.self.x, y: player.self.y }
				);
				// this.navMesh.enableDebug(); // Creates a Phaser.Graphics overlay on top of the screen
				// Visualize the underlying navmesh
				// this.navMesh.debugDrawMesh({
				// 	drawCentroid: true,
				// 	drawBounds: false,
				// 	drawNeighbors: true,
				// 	drawPortals: true
				// });
				// Visualize an individual path
				// this.navMesh.debugDrawPath(path, 0xffd900);

				child.newTarget(path);
			}
		}
	}

	// This function is defined here, for use when either of the zombies touch eachother's hitbox.
	private zombieCollide(zombie1: Zombie, zombie2: Zombie): void {
		// Get the distance between the zombies
		const dx: number = zombie2.x - zombie1.x;
		const dy: number = zombie2.y - zombie1.y;
		// Get the direction from zombie 1 to Zombie 2 (0->2Pi)
		const dir: number = Math.atan2(dy, dx);

		if (this.allowZombieCollide) {
			zombie1.setHitstun(15, 200, dir + Math.PI, 0, 0);
			zombie2.setHitstun(15, 200, dir, 0, 0);
		} else {
			zombie1.requestNewPath = true;
			zombie2.requestNewPath = true;
		}
	}
}
